var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"shop-app base"},[_c('AppRouteLoadingBar'),_c(_vm.appComponent,{tag:"component",attrs:{"id":"app"}}),_c('ClientSideOnly',[_c('AppMessageDialog',{ref:"appMessageDialog"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }